import { Button, cx, Icon } from 'leanplum-lib-ui';
import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import './SplitPane.scss';

@Component({ name: 'SplitPane' })
export class SplitPane extends Vue {
  static readonly EVENT_TOGGLE: string = 'toggle';

  @Prop({ required: false, type: String })
  readonly width: string;

  @Prop({ required: false, type: Boolean })
  readonly collapsible: boolean;

  private isCollapsed: boolean = false;

  render(): VNode {
    return (
      <div
        class={cx('lp-split-pane', {
          'fixed': Boolean(this.width),
          'collapsed': this.isCollapsed
        })}
        style={{ 'flex-basis': this.computedWidth }}
      >
        {this.collapsible && (
          <Button
            class="collapse-button"
            color={Button.Color.LIGHT}
            icon={Icon.Type.CHEVRON_LEFT}
            iconSize={16}
            onClick={this.onClick}
          />
        )}
        {!this.isCollapsed && this.$slots.default}
      </div>
    );
  }

  private get computedWidth(): string {
    if (!this.isCollapsed && this.width) {
      return this.width;
    }

    return 'auto';
  }

  private onClick(): void {
    this.isCollapsed = !this.isCollapsed;
    this.$emit(SplitPane.EVENT_TOGGLE, !this.isCollapsed);
  }
}
